const _excluded = ["fieldName", "label", "onChange", "values", "required", "valueAttributeName", "textAttributeName", "valueFn", "multiple", "labelMd", "fieldMd"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getNestedValue } from '../objectUtils';
export default function DropdownFormField(_ref) {
  let {
      fieldName,
      label,
      onChange,
      values,
      required,
      valueAttributeName,
      textAttributeName,
      valueFn,
      multiple = false,
      labelMd = 6,
      fieldMd = undefined
    } = _ref,
    selectProps = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  textAttributeName || (textAttributeName = valueAttributeName);
  if (valueAttributeName && valueFn) {
    console.error('SelectFormField received both valueFn and valueAttribute props. This should not happen.');
  }
  let options = [];
  if (valueFn) {
    options = (values || []).map((value, index) => valueFn(value, index));
  } else {
    options = (values || []).map((value, index) => /*#__PURE__*/React.createElement("option", {
      key: value.id || "option-index-".concat(index),
      value: typeof value === 'string' ? value : getNestedValue(value, valueAttributeName)
    }, typeof value === 'string' ? t(value) : t(getNestedValue(value, textAttributeName))));
  }
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: labelMd
  }, t("".concat(label || fieldName)), required ? '*' : ''), /*#__PURE__*/React.createElement(Col, {
    md: fieldMd
  }, /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: "select",
    name: fieldName,
    onChange: e => {
      multiple ? onChange(Array.from(e.target.selectedOptions).map(o => o.value), e.target.selectedOptions) : onChange(e.target.value);
    },
    size: "md",
    multiple: multiple
  }, selectProps), /*#__PURE__*/React.createElement("option", {
    value: null
  }), options)));
}